const INDEX_ITEMS = [
  { id: 1, label: '91年国产电影', icon: 'ri-film-line', count: '856部' },
  { id: 2, label: '国产电视剧', icon: 'ri-tv-line', count: '1,240部' },
  { id: 3, label: '国产综艺', icon: 'ri-emotion-laugh-line', count: '632部' },
  { id: 4, label: '纪录片', icon: 'ri-record-circle-line', count: '418部' },
  { id: 5, label: '动画片', icon: 'ri-movie-line', count: '295部' },
  { id: 6, label: '经典回顾', icon: 'ri-history-line', count: '520部' },
  { id: 7, label: '高分推荐', icon: 'ri-star-line', count: '380部' },
  { id: 8, label: '最新上线', icon: 'ri-rocket-line', count: '156部' },
  { id: 9, label: '悬疑推理', icon: 'ri-search-eye-line', count: '273部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">片库索引</h2>
          <p className="text-sm md:text-base text-foreground-500">按分类浏览91国产视频全部影视资源</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl p-4 md:p-5 text-center cursor-pointer hover:bg-background-200 transition-colors group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg md:text-xl text-primary-500`}></i>
              </div>
              <div className="text-sm md:text-base font-semibold text-foreground-800 mb-1 whitespace-nowrap">{item.label}</div>
              <div className="text-xs text-foreground-400">{item.count}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}